export const INITIAL_ZOOM = 2
export const MAX_ZOOM_IN = 6
export const MAX_ZOOM_OUT = 1
export const ZOOM_STEP = 1
